import Alpine from './alpine'

/**
 * Toasts.
 *
 * Deliberately a queue rather than a single slot: a bulk action can finish
 * several operations at once and each deserves its own confirmation.
 */
Alpine.store('toast', {
    items: [],
    nextId: 1,

    push(message, { type = 'success', duration = 5000, action = null } = {}) {
        const id = this.nextId++

        this.items.push({ id, message, type, action })

        if (duration > 0) {
            setTimeout(() => this.dismiss(id), duration)
        }

        return id
    },

    success(message, options = {}) {
        return this.push(message, { ...options, type: 'success' })
    },

    error(message, options = {}) {
        // Errors stay until dismissed - they usually need the operator to act.
        return this.push(message, { duration: 0, ...options, type: 'critical' })
    },

    info(message, options = {}) {
        return this.push(message, { ...options, type: 'info' })
    },

    dismiss(id) {
        this.items = this.items.filter((item) => item.id !== id)
    },
})

/**
 * The contextual save bar, which replaces the top bar whenever a form on the
 * page is dirty. Forms register themselves so Save/Discard can reach them
 * without the bar knowing what it is saving.
 */
Alpine.store('saveBar', {
    visible: false,
    saving: false,
    message: 'Unsaved changes',
    form: null,

    show(form, message = 'Unsaved changes') {
        this.form = form
        this.message = message
        this.visible = true
    },

    hide() {
        this.visible = false
        this.saving = false
        this.form = null
    },

    save() {
        if (!this.form) return
        this.saving = true
        this.form.requestSubmit ? this.form.requestSubmit() : this.form.submit()
    },

    discard() {
        if (!this.form) return
        this.form.reset()
        this.form.dispatchEvent(new CustomEvent('form-discarded', { bubbles: true }))
        this.hide()
    },
})

/**
 * Left navigation.
 *
 * Only the mobile drawer has state. There used to be a persisted `collapsed`
 * flag for a rail that could be folded away, but the column no longer offers
 * that - like the live admin, it is always the same width and its sub-items
 * appear because of where you are, not because of what you last clicked. A
 * stored preference nothing can set or read is a bug waiting for a reader.
 */
Alpine.store('nav', {
    mobileOpen: false,

    openMobile() {
        this.mobileOpen = true
        document.body.style.overflow = 'hidden'
    },

    closeMobile() {
        this.mobileOpen = false
        document.body.style.overflow = ''
    },
})
